import { Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { CollectiblesPage } from '../collectibles/collectibles'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-collectiblesreward',
  templateUrl: 'collectiblesreward.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class CollectiblesRewardPage {
  stepCollectible:any;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController, public navParams: NavParams) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);

    this.stepCollectible = this.navParams.get('stepCollectible'); 
  }  
  
  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  
  goToCollectibles(){
    this.navCtrl.setRoot(CollectiblesPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/collectiblesreward/collectiblesreward.ts